import Chart from 'chart.js';

// ==============================
// データラベルプラグインのクラス
// ==============================
class DataLabelPlugin {
	constructor(dateNumArray) {
		// 各データに付ける番号やラベル（例: ①, ②, ③...）
		this.dateNumArray = dateNumArray;
	}

	// データセット描画後に呼ばれるフック
	afterDatasetsDraw(chart) {
		const ctx = chart.ctx; // Canvasの描画コンテキストを取得
		chart.data.datasets.forEach((dataset, i) => {
			// データ合計値を計算（％表示用）
			let dataSum = dataset.data.reduce((sum, element) => sum + element, 0);
			const meta = chart.getDatasetMeta(i); // データセットのメタ情報を取得

			// 非表示でなければ処理
			if (!meta.hidden) {
				meta.data.forEach((element, index) => {
					// 描画スタイルを指定
					ctx.fillStyle = 'rgb(255, 255, 255)'; // 白文字
					const fontSize = 16;
					const fontStyle = 'normal';
					const fontFamily = 'Varela Round';
					ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);

					// データを％に変換して文字列化（小数点1桁）
					const dataString = `${(Math.round(dataset.data[index] / dataSum * 1000) / 10).toString()}%`;

					ctx.textAlign = 'center';
					ctx.textBaseline = 'middle';
					const padding = 5;
					const position = element.tooltipPosition(); // データの座標位置を取得

					// ラベル番号と％をCanvas上に描画
					ctx.fillText(
						`${this.dateNumArray[index]}${dataString}`,
						position.x,
						position.y + (fontSize / 2) - padding
					);
				});
			}
		});
	}
}

// ==============================
// チャート生成の共通関数
// ==============================
function createChart(type, ctxSelector, data, options, plugins) {
	const ctx = $(ctxSelector).get(0).getContext('2d'); // jQueryでCanvasを取得
	const chartFactory = new ChartFactory(type, ctx, data, options, plugins);
	chartFactory.createChart();
	return chartFactory;
}

// ==============================
// チャートを生成するクラス
// ==============================
class ChartFactory {
	constructor(type, ctx, data, options, plugins) {
		this.type = type;       // チャートタイプ（例: doughnut, bar）
		this.ctx = ctx;         // 描画コンテキスト
		this.data = data;       // データセット
		this.options = options; // オプション設定
		this.plugins = plugins; // プラグイン配列
		this.chart = null;      // 実際のChartインスタンスを保持
	}

	// チャートを生成
	createChart() {
		this.chart = new Chart(this.ctx, {
			type: this.type,
			data: this.data,
			options: this.options,
			plugins: this.plugins
		});
	}

	// データ更新用メソッド
	updateData(newData) {
		this.chart.data.datasets[0].data = newData;
		this.chart.update();
	}
}

// ==============================
// データラベルプラグインのインスタンス生成
// ==============================
const dateNumArray = ['①', '②', '③', '④', '⑤'];
const dataLabelPlugin = new DataLabelPlugin(dateNumArray);

// ==============================
// ドーナツチャートの設定
// ==============================
const doughnutChartData = [
	{
		// チャート1のデータ
		labels: ["①テキスト１", "②テキスト２", "③テキスト３", "④テキスト５", "⑤テキスト６"],
		datasets: [{
			backgroundColor: ["#0084c7", "#f06200", "#009e62", "#efa600", "#e8374a"],
			data: $('.js-doughnut_chart01').data('data') // data属性から数値を取得
		}]
	},
	{
		// チャート2のデータ
		labels: ["①テキスト１", "②テキスト２", "③テキスト３", "④テキスト５"],
		datasets: [{
			backgroundColor: ["#0084c7", "#f06200", "#009e62", "#efa600"],
			data: $('.js-doughnut_chart02').data('data')
		}]
	},
];

// チャート全体のオプション
const doughnutChartOptions = {
	legend: { display: false }, // 凡例は非表示
	maintainAspectRatio: false  // アスペクト比を固定しない
};

// 使用するプラグイン
const doughnutChartPlugins = [dataLabelPlugin];

// ==============================
// 実際にチャートを描画する関数
// ==============================
export function chart() {
	// ドーナツチャート1を作成
	if ($('.js-doughnut_chart01').length) {
		const myDoughnutChart01 = createChart(
			'doughnut',
			'.js-doughnut_chart01',
			doughnutChartData[0],
			doughnutChartOptions,
			doughnutChartPlugins
		);
	}
	// ドーナツチャート2を作成
	if ($('.js-doughnut_chart02').length) {
		const myDoughnutChart02 = createChart(
			'doughnut',
			'.js-doughnut_chart02',
			doughnutChartData[1],
			doughnutChartOptions,
			doughnutChartPlugins
		);
	}
}

// ==============================
// （コメントアウト）バーチャートの例
// ==============================
// const barChartData = {
// 	labels: ["①テキスト１", "②テキスト２", "③テキスト３", "④テキスト５", "⑤テキスト６"],
// 	datasets: [{
// 		backgroundColor: ["#0084c7", "#f06200", "#009e62", "#efa600", "#e8374a"],
// 		data: $('#barChart').data('data')
// 	}]
// };

// const barChartOptions = {
// 	legend: { display: false },
// 	maintainAspectRatio: true
// };

// const barChartPlugins = [dataLabelPlugin];

// const myBarChart = createChart('bar', '#barChart', barChartData, barChartOptions, barChartPlugins);
